import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import { StoreState } from '../../../reducers';
import { connect } from 'react-redux';
import { AppType } from '../../App/reducer';
import ShareButton from '../../../components/Share/ShareButton';
import RoutesUtils from '../../../utils/routes';

interface OwnShareButtonProps {
	driveItems?: Api.DriveItem[];
}

const mapStateToProps = (state: StoreState, ownProps: OwnShareButtonProps) => {
	const { galleryInfos, appInfos, authentication, driveList, routerParamsHistory } = state;
	const { driveItems } = ownProps;
	const { needCredentials } = authentication.userInfos;
	const driveItemsStore = driveList.driveItems;
	const galleryConfig = galleryInfos.config;
	const galleryId = galleryConfig.applicationGallery;
	const type = appInfos.type || AppType.Single;
	const isNativeShare = UserAgentUtils.isMobileApp && !Utils.isSecure(type, needCredentials);

	// if Share shouldn't be native and the path is the gallery root, we send the gallery as the shared item
	const isGalleryRoot = RoutesUtils.isGalleryRoot(routerParamsHistory);
	const sharedItems = !isNativeShare && isGalleryRoot ? [driveItemsStore[galleryId]] : driveItems;

	return { galleryConfig, isNativeShare, sharedItems};
};

export default connect(mapStateToProps)(ShareButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/ShareButton/index.tsx